var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagramSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.51-.001H6.49A6.5 6.5 0 000 6.489v11a6.506 6.506 0 006.49 6.51h11a6.506 6.506 0 006.51-6.49V6.489a6.5 6.5 0 00-6.49-6.49zm5.09 17.51a5.09 5.09 0 01-5.09 5.09H6.49a5.09 5.09 0 01-5.09-5.09V6.489a5.09 5.09 0 015.09-5.09h11a5.09 5.09 0 015.09 5.09v11.02zM11.951 5.534a6.465 6.465 0 106.465 6.465 6.459 6.459 0 00-6.465-6.465zm0 11.559a5.094 5.094 0 115.094-5.094 5.106 5.106 0 01-5.094 5.094zm8.718-12.049a1.935 1.935 0 11-1.934-1.935 1.923 1.923 0 011.934 1.935z",
    fill: "#555"
  })));
}

export default __webpack_public_path__ + "static/media/instagram_sm.c6103d39d7e92bd5187ce9508a54aca4.svg";
export { SvgInstagramSm as ReactComponent };